export const skbv = {
  white: "#ffffff",
  light: "#F8F8F2",
  primary: "#1b5f4b",
  secondary: "#faf9f8",
  lightGrey: "#faf9f8",
  progressBar: "#1b5f4b",
  progressBarHighlight: "#438d6d",
  dark: "#438d6d",
  grey: "#888888",
  darkGrey: "#4f504a",
  link: "#1b5f4b",
  discount: "#a5423f",
  input: "#1d1d1d",
  fontFamilyPrimary: "aktiv-grotesk, sans-serif",
  fontFamilySecondary: "united-sans, sans-serif",
  tableHeader: "#ebebdb",
  hover: "#c1dfd4",
  spinner: "#1b5f4b",
  headingTransform: "uppercase",
  inspirationText: "#1b5f4b",
};

export const nordrum = {
  white: "#ffffff",
  light: "#F8F8F2",
  primary: "#65b32e",
  secondary: "#f1f1f2",
  lightGrey: "#f2f3ec",
  progressBar: "#2e2e2e",
  progressBarHighlight: "#1e1e1e",
  dark: "#466d46",
  grey: "#888888",
  darkGrey: "#616161",
  link: "#65b32e",
  discount: "#a70000",
  input: "#111111",
  fontFamilyPrimary: "poppins, sans-serif",
  fontFamilySecondary: "poppins, sans-serif",
  tableHeader: "#d8d4c4",
  hover: "#d8d4c4",
  spinner: "#65b32e",
  headingTransform: "unset",
  inspirationText: "#324c31",
};
